export default __webpack_public_path__ + "514b92af7a2fdcb3373a422a41469c7c.svg";